import moment from "moment";

export const everDrivenLogoUrl =
  "https://res.cloudinary.com/dgjordf6e/image/upload/v1780556176/everdriven-logo-removebg-preview_yqu7sx.png";

export const everDrivenInspectionPointColumns = [
  [
    { number: 1, label: "Foot brakes" },
    { number: 2, label: "Emergency brake (parking brake)" },
    { number: 3, label: "Steering mechanism" },
    { number: 4, label: "Windshield" },
    { number: 5, label: "Rear window and other glass" },
    { number: 6, label: "Windshield wipers" },
    { number: 7, label: "Headlights" },
    { number: 8, label: "Tail lights" },
    { number: 9, label: "Turn indicator lights" },
    { number: 10, label: "Stop lights" },
    { number: 11, label: "Front seat adjustment" },
    { number: 12, label: "Doors (open, close, lock)" },
  ],
  [
    { number: 13, label: "Horn" },
    { number: 14, label: "Speedometer" },
    { number: 15, label: "Bumpers" },
    { number: 16, label: "Muffler and exhaust system" },
    { number: 17, label: 'Tires, incl. tread depth (minimum 2/32")' },
    { number: 18, label: "Interior and exterior rear view mirrors" },
    { number: 19, label: "Safety belts for driver and passenger" },
    { number: 20, label: "Fire extinguisher and first aid kit" },
  ],
];

export const humanTickPaths = [
  "M4 12.5C6.3 15.4 8.1 17.7 9.2 18.7C12.5 13.5 16.1 8.8 21 4.4",
  "M3.5 13.2C5.9 14.9 7.6 17.1 9.5 19.2C12.2 13.2 16.6 7.7 20.6 5.2",
  "M4.2 11.8C6.7 14.1 8.3 16.6 10.1 18.1C13.4 12.2 16.7 8.1 21.4 4.8",
  "M3.9 12.9C6 15.2 7.8 16.7 9.7 18.8C12.3 13.6 15.9 7.9 20.8 5",
  "M4.1 13.4C6.5 15 8.5 17.8 9.6 18.9C12.7 12.9 16.9 8.2 21.2 4.7",
];

export const handDrawnCirclePath =
  "M52.1927 2.90815C34.1317 2.90815 15.3734 8.31886 6.56927 25.4371C3.77005 30.8798 1.5 32.7484 1.5 38.8919C1.5 44.4471 5.2551 50.3534 10.1902 53.2854C14.6663 55.9447 15.5908 61.4646 20.3287 63.7676C25.118 66.0956 26.9011 68.1651 32.5593 69.1652C42.084 70.8488 57.582 73.3293 66.6763 69.3999C70.4649 67.7629 77.2718 68.2962 81.4818 67.366C84.6931 66.6565 103.112 62.3328 104.253 58.4483C106.691 50.1537 115.056 36.3085 107.23 28.2532C102.352 23.2319 97.9017 18.6987 91.2985 15.5807C86.0695 13.1115 82.0045 12.4543 76.8149 10.6525C70.3868 8.42063 63.9661 4.31621 57.262 4.31621C51.9098 4.31621 47.9811 4.76555 43.5025 1.50009";

export const getVinCells = (value = "") =>
  String(value || "")
    .replace(/\s+/g, "")
    .toUpperCase()
    .slice(0, 17)
    .padEnd(17, " ")
    .split("");

export const normalizeEverDrivenValue = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const getEverDrivenFullName = (data = {}) =>
  `${data?.Username || ""} ${data?.UserlastName || ""}`.trim();

export const getEverDrivenInspectorName = (data = {}) =>
  `${data?.Inspectorname || ""} ${data?.InspectorlastName || ""}`.trim();

export const formatEverDrivenDate = (value, format = "MM/DD/YYYY") =>
  value ? moment(value).format(format) : "";
